// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1488":"61d6589c","2139":"3f87c583","2415":"25c04595","3801":"a5f3cf4a","6407":"5a8df817","7628":"5383a460"}[chunkId] + ".css";
};